<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { boardKey } from "@/components/board/injectKeys";
import SetWsjf from "@/components/menu/SetWsjf/SetWsjf.vue";
import { isRiskBoard, isTeamBoard } from "@/model/board";
import { useServerSettingsStore } from "@/store/serverSettings";
import { useWorkModeStore } from "@/store/workMode";
import { injectStrict } from "@/utils/vue";

import { toElipsis } from "../utils";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const wsjf = computed(() => card.type.priorities?.[card.priority]?.text || card.priority + "");

const isVisible = computed(() => {
  // hide it when the sticky was created on the team board
  if (card.type.origin === "team") return false;
  // hide it on the team board and the risk board
  if (isTeamBoard(board.value.type) || isRiskBoard(board.value.type)) {
    return false;
  }

  return useWorkModeStore().isExecutionMode;
});
</script>

<template>
  <ActionMenuDropdown
    v-if="isVisible"
    :action="cardActions.setPriority"
    :tooltip="
      useServerSettingsStore().isPriorityEditable
        ? $t('actionMenu.wsjf', { value: wsjf })
        : $t('actionMenu.wsjf.readonly', { value: wsjf })
    "
    :disabled="!useServerSettingsStore().isPriorityEditable"
    width="auto"
  >
    <template #content>
      <span class="wsjf-item" :aria-label="$t('actionMenu.wsjf', { value: wsjf })">
        {{ toElipsis(wsjf) }}
      </span>
    </template>
    <SetWsjf v-focus-trap />
  </ActionMenuDropdown>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";
@use "@/styles/variables/colors";

.wsjf-item {
  @include typography.small("bold");

  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  background-color: colors.$background-ui;
  border-radius: 4px;
  color: colors.$text;
}
</style>
